// Elite = one tier under Alpha. A high-quality market SETUP based on the criteria
// below. The two security checks (mint renounced / freeze disabled) come from
// RugCheck and are verified on the coin detail page, not the radar list.
import { fmtUsd, fmtAge } from "./format";

export function eliteCheck(coin) {
  const liq = coin.liquidity || 0;
  const vol = coin.volume?.h24 || 0;
  const mcap = coin.marketCap || 0;
  const age = coin.ageHours;
  const tx = (coin.txns?.h24?.buys || 0) + (coin.txns?.h24?.sells || 0);

  const criteria = [
    { key: "liq", label: "Liquidity ≥ $100k", pass: liq >= 100000, detail: fmtUsd(liq) },
    { key: "vol", label: "24h Volume ≥ $250k", pass: vol >= 250000, detail: fmtUsd(vol) },
    { key: "mcap", label: "Market Cap $50k–$5M", pass: mcap >= 50000 && mcap <= 5000000, detail: fmtUsd(mcap) },
    { key: "age", label: "Age 1h–48h", pass: age != null && age >= 1 && age <= 48, detail: fmtAge(age) },
    { key: "txns", label: "24h Txns ≥ 500", pass: tx >= 500, detail: `${tx.toLocaleString()} txns` },
  ];
  const passCount = criteria.filter((c) => c.pass).length;
  return { isElite: passCount === criteria.length, passCount, total: criteria.length, criteria };
}
